



















































import { Vue, Component, Prop } from "vue-property-decorator";
import { required } from "vuelidate/lib/validators";
import { BaseDialog, Button, Input, SvgIcon, Textbox } from "@brankas/web-ui";

@Component({
  components: {
    BaseDialog,
    Button,
    Input,
    SvgIcon,
    Textbox,
  },
  validations: {
    formData: {
      reason: {
        required,
      },
    },
  },
})
export default class RevokeLiveDialog extends Vue {
  @Prop({ type: Boolean, default: false }) loading!: boolean;
  formData = {
    reason: "",
  };

  onCancel() {
    this.$emit("cancel");
  }

  onConfirm() {
    if (this.$v.$invalid) {
      return;
    }
    this.$emit("confirm", this.formData.reason);
  }
}
